import {
  allPartnerMenuList,
  partnerMenuCreate,
  partnerMenuEdit,
  partnerMenuDelete,
} from '@/services/menu';

export default {
  namespace: 'PlatformManager_partnerMenu',

  state: {
    data: {},
    menuData: {},
    userInfo: {},
    result: {},
  },

  effects: {
    *fetch({ payload }, { call, put }) {
      const {
        data: { data },
      } = yield call(allPartnerMenuList, payload);

      yield put({
        type: 'save',
        payload: {
          list: data,
        },
      });
    },
    *create({ payload }, { call, put }) {
      const { data } = yield call(partnerMenuCreate, payload);
      yield put({
        type: 'saveResult',
        payload: data,
      });
    },
    *edit({ payload }, { call, put }) {
      const { data } = yield call(partnerMenuEdit, payload);
      yield put({
        type: 'saveResult',
        payload: data,
      });
    },
    *delete({ payload }, { call, put }) {
      const { data } = yield call(partnerMenuDelete, payload);
      yield put({
        type: 'saveResult',
        payload: data,
      });
    },
  },
  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        data: payload,
      };
    },
    saveResult(state, { payload }) {
      return {
        ...state,
        result: payload,
      };
    },
  },
};
